import { render, staticRenderFns } from "./emscrapList.vue?vue&type=template&id=2c36f628&scoped=true"
import script from "./emscrapList.vue?vue&type=script&lang=js"
export * from "./emscrapList.vue?vue&type=script&lang=js"
import style0 from "./emscrapList.vue?vue&type=style&index=0&id=2c36f628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36f628",
  null
  
)

export default component.exports